import { useState, useEffect } from "react";
import "./CreateResourceRegForm.css";
import { getData, postDataWithBody, putDataWithBody } from "../../../../Services/Services";
import { Allassetcategory, getAllRole, getbarches, getThemeURL, rolebaseuser, getassetsubcategory, stafftype, saveapires, updateresource, getallBanksByRole } from "../../../../Services/EndPoints";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from "react-bootstrap/Modal";

/* This component provides a form for creating or editing resource requests. */
const CreateResourceRegForm = () => {
  // State management
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    jobTitle: "",
    requestorName: "",
    bankName: "",
    branchName: "",
    assignedRole: "",
    assignedUser: "",
    requestType: "",
    department: "",
    requestDate: "",
    reporteddate: "", // Format for datetime-local
    description: "",
    requestedByDepartment: "",
    email: "",
    contactNumber: "",
    assetCategory: "",
    assetType: "",
    // Staff-specific fields
    staffType: "",
    skillSet: "",
    experienceLevel: "",
    employmentType: "",
    // Asset-specific fields
    assetName: "",
    quantity: "",
    nonFunctionalUnits: "",
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({}); // Track which fields have been touched
  const [bankOptions, setBankOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [allrole, setallrole] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [username, setusername] = useState(null);
  const [userId, setUserId] = useState(null); // To store the current user's ID
  const [assetcategory1, setassetcategory] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [staffTypes, setStaffTypes] = useState([]);
  const [submitted, setSubmitted] = useState(false); // Track if form was submitted
  const navigate = useNavigate();
  const location = useLocation();
  const { data, edit } = location.state || {};
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(!!edit);
  const [resourceId, setResourceId] = useState(null); // To store the resource ID for updates

  // Asset and Staff resource IDs for edit mode
  const [assetResourceId, setAssetResourceId] = useState(null);
  const [staffResourceId, setStaffResourceId] = useState(null);

  /* Validates the Job Title field */
  const validateJobTitle = (value) => {
    if (!value || !value.trim()) {
      return "Resource Title is required";
    }
    if (value.trim().length < 3) {
      return "Resource Title must be at least 3 characters";
    }
    if (value.trim().length > 100) {
      return "Resource Title must be less than 100 characters";
    }
    if (!/^[a-zA-Z0-9 ]+$/.test(value)) {
      return "Job title can only contain letters, numbers, and spaces";
    }
    return "";
  };

  const validateBankName = (value) => {
    if (!value) return "Bank Name is required";
    return "";
  };

  const validateBranchName = (value) => {
    if (!value) return "Branch Name is required";
    return "";
  };

  const validateAssignedRole = (value) => {
    if (!value) return "Assigned Role is required";
    return "";
  };

  const validateAssignedUser = (value) => {
    if (!value) return "Assigned User is required";
    return "";
  };

  const validateRequestType = (value) => {
    if (!value) return "Request Type is required";
    return "";
  };

  const validateReportedDate = (value) => {
    if (!value) return "Requested Date & Time is required";

    const selectedDate = new Date(value);
    const currentDate = new Date();

    if (isNaN(selectedDate.getTime())) {
      return "Please Enter a valid date";
    }

    if (selectedDate > currentDate) {
      return "Date cannot be in the future";
    }

    return "";
  };

  const validateDescription = (value) => {
    if (!value || !value.trim()) {
      return "Resource Description is required";
    }
    if (value.trim().length > 250) {
      return "Resource Description must be less than 250 characters";
    }
    return "";
  };

  const validateRequestedByDepartment = (value) => {
    if (!value || !value.trim()) {
      return "Requested By Department is required";
    }
    if (value.trim().length < 3) {
      return "Requested By Department must be at least 3 characters";
    }
    if (!/^[a-zA-Z ]+$/.test(value)) {
      return "Requested By Department can only contain letters and spaces";
    }
    return "";
  };

  const validateEmail = (value) => {
    if (!value || !value.trim()) {
      return "Email Address is required";
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "Enter a valid Email Address (e.g., user@example.com)";
    }
    return "";
  };

  const validateContactNumber = (value) => {
    if (!value || !value.trim()) {
      return "Contact Number is required";
    }
    if (!/^[0-9]{10,15}$/.test(value)) {
      return "Contact Number must be 10 digits";
    }
    if (/^[0-5]/.test(value)) {
      return "Contact Number cannot start with digits 0-5";
    }
    return "";
  };

  // Staff-specific validations
  const validateStaffType = (value) => {
    if (!value) return "Staff Type is required";
    return "";
  };

  const validateSkillSet = (value) => {
    if (value && !/^[a-zA-Z, ]+$/.test(value)) {
      return "Skills can only contain letters and commas";
    }
    return "";
  };

  const validateExperienceLevel = (value) => {
    if (!value) return "Experience Level is required";
    return "";
  };

  const validateEmploymentType = (value) => {
    if (!value) return "Employment Type is required";
    return "";
  };

  // Asset-specific validations
  const validateAssetCategory = (value) => {
    if (!value) return "Asset Category is required";
    return "";
  };

  const validateAssetType = (value) => {
    if (!value) return "Asset Type is required";
    return "";
  };

  const validateAssetName = (value) => {
    if (!value || !value.trim()) {
      return "Asset Name is required";
    }
    if (value.trim().length < 3) {
      return "Asset Name must be at least 3 characters";
    }
    if (value.trim().length > 100) {
      return "Asset Name must be less than 100 characters";
    }
    return "";
  };

  const validateQuantity = (value) => {
    if (!value) return "Quantity Required is required";
    if (isNaN(value) || parseInt(value) <= 0) {
      return "Quantity Required must be a positive number";
    }
    return "";
  };

  const validateNonFunctionalUnits = (value) => {
    if (value && (isNaN(value) || parseInt(value) < 0)) {
      return "Must be zero or a positive number";
    }
    return "";
  };

  // Parse the resource data if in edit mode
  useEffect(() => {
    if (data && edit) {
      try {
        setIsEditMode(true);
        setResourceId(data.id);

        // Set asset or staff resource ID if available
        if (data.asset_resource && data.asset_resource.length > 0) {
          setAssetResourceId(data.asset_resource[0].id);
        }
        if (data.staff_resource && data.staff_resource.length > 0) {
          setStaffResourceId(data.staff_resource[0].id);
        }

        setFormData({
          jobTitle: data.jobTitle || "",
          requestorName: data.requestorName || username,
          bankName: data.bankId?.toString() || "",
          branchName: data.branchId?.toString() || "",
          assignedRole: data.assigned_team || "",
          assignedUser: data.asset_resource?.length > 0
            ? data.asset_resource[0].assignedTo?.toString()
            : data.staff_resource?.length > 0
              ? data.staff_resource[0].assignedTo?.toString()
              : "",
          requestType: data.requestType || "",
          department: "", // Not provided in data
          requestDate: new Date().toISOString().split('T')[0], // Current date
          reporteddate: data.requestDateAndTime,
          description: data.description || "",
          requestedByDepartment: data.reqByDepartment || "",
          email: data.email || "",
          contactNumber: data.phoneNumber || "",

          // Asset-specific fields
          assetCategory: data.asset_resource?.length > 0 ? data.asset_resource[0].assetCategoryId?.toString() : "",
          assetType: data.asset_resource?.length > 0 ? data.asset_resource[0].assetTypeId?.toString() : "",
          assetName: data.asset_resource?.length > 0 ? data.asset_resource[0].assetName : "",
          quantity: data.asset_resource?.length > 0 ? data.asset_resource[0].quantity?.toString() : "",
          nonFunctionalUnits: data.asset_resource?.length > 0 ? data.asset_resource[0].nonFunctionalUnits?.toString() : "",

          // Staff-specific fields
          staffType: data.staff_resource?.length > 0 ? data.staff_resource[0].staffId?.toString() : "",
          skillSet: data.staff_resource?.length > 0 ? data.staff_resource[0].skills : "",
          experienceLevel: data.staff_resource?.length > 0 ? data.staff_resource[0].expLevel : "",
          employmentType: data.staff_resource?.length > 0 ? data.staff_resource[0].employmentType : "",
        });

        // Fetch dependent data based on the existing values
        if (data.bankId) {
          fetchBranches(data.bankId.toString());
        }
        if (data.assigned_team) {
          fetchUsersByRole(data.assigned_team);
        }
        if (data.asset_resource?.length > 0 && data.asset_resource[0].assetCategoryId) {
          fetchSubCategories(data.asset_resource[0].assetCategoryId.toString());
        }
      } catch (error) {
        console.error("Error parsing edit data:", error);
        toast.error("Error loading resource data for editing");
      }
    }
  }, [data, edit]);

  useEffect(() => {
    const fetchMasterData = async () => {
      setIsLoading(true);
      try {
        // Get user profile first
        const userProfile = await getData(getThemeURL);

        if (userProfile && Array.isArray(userProfile) && userProfile.length > 0) {
          const user = userProfile[0];

          // Create payload based on user profile
          let adminRole = "U"; // default
          if (user.role_name === "HO") {
            adminRole = "HO";
          } else if (user.role_name === "SUPER ADMIN") {
            adminRole = "SA";
          }

          const payload = {
            admin_role: adminRole,
            bank_id: user.bank_id || null,
            branch_id: user.branch_id || null // assuming agency_id is branch_id
          };

          const response = await postDataWithBody(getallBanksByRole, payload, {});
          if (response && Array.isArray(response)) {
            setBankOptions(response);
          }

          const userData = {
            name: user.user_name,
            department: "Finance" // or derive from user data if available
          };

          setFormData(prev => ({
            ...prev,
            requestorName: user.user_name,
            department: userData.department
          }));

          // Set username and userId
          setusername(user.user_name);
          setUserId(user.id);
        }
      } catch (error) {
        console.error("Error fetching master data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMasterData();
  }, []);

  useEffect(() => {
    fetchAllRoles();
    fetchUserProfile();
    fetchcategory();
    fetchstaffdetails();
  }, []);

  // Fetches staff type details from API
  const fetchstaffdetails = async () => {
    try {
      let request = ["STAFF_CAT"]
      const response = await postDataWithBody(stafftype, request, {})
      if (Array.isArray(response)) {
        setStaffTypes(response);
      }
    } catch (error) {
      console.error("Error fetching staff details:", error);
    }
  }

  useEffect(() => {
    if (formData.assetCategory) {
      fetchSubCategories(formData.assetCategory);
    } else {
      setSubCategories([]);
    }
  }, [formData.assetCategory]);

  // Fetches subcategories for the selected asset category
  const fetchSubCategories = async (categoryId) => {
    try {
      const response = await getData(getassetsubcategory.replace("ID", categoryId));
      if (Array.isArray(response)) {
        setSubCategories(response);
      }
    } catch (error) {
      console.error("Error fetching subcategories", error);
    }
  };

  // Fetches all roles from API
  const fetchAllRoles = async () => {
    try {
      const response = await getData(getAllRole);
      if (response && Array.isArray(response)) {
        setallrole(response);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  }

  // Fetches current user profile data
  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setusername(response[0].user_name);
        setUserId(response[0].id); // Store the user ID for later use
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  }

  // Fetches asset categories from API
  const fetchcategory = async () => {
    try {
      let request = ["ASSET_CAT"]
      const response = await postDataWithBody(Allassetcategory, request, {})
      if (response && Array.isArray(response)) {
        setassetcategory(response);
      }
    } catch (error) {
      console.error("Error fetching asset categories:", error);
    }
  }

  // Effect hook to fetch users by role when assigned role changes
  useEffect(() => {
    if (formData.assignedRole) {
      fetchUsersByRole(formData.assignedRole);
    } else {
      setAssignedUsers([]);
    }
  }, [formData.assignedRole]);

  // Fetches users for the selected role
  const fetchUsersByRole = async (roleId) => {
    try {
      const response = await getData(rolebaseuser.replace("ID", roleId));
      if (Array.isArray(response)) setAssignedUsers(response);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // Effect hook to fetch branches when bank selection changes
  useEffect(() => {
    if (formData.bankName) {
      fetchBranches(formData.bankName);
    } else {
      setBranchOptions([]);
    }
  }, [formData.bankName]);

  // Fetches branches for the selected bank
  const fetchBranches = async (bankId) => {
    try {
      const response = await getData(getbarches.replace("ID", bankId));
      setBranchOptions(response);
    } catch (error) {
      console.error("Error fetching branches:", error);
      setBranchOptions([]);
    }
  };

  // Validates the entire form
  const validateForm = () => {
    const validationErrors = {};

    // Common validations
    validationErrors.jobTitle = validateJobTitle(formData.jobTitle);
    validationErrors.bankName = validateBankName(formData.bankName);
    validationErrors.branchName = validateBranchName(formData.branchName);
    validationErrors.assignedRole = validateAssignedRole(formData.assignedRole);
    validationErrors.assignedUser = validateAssignedUser(formData.assignedUser);
    validationErrors.requestType = validateRequestType(formData.requestType);
    validationErrors.reporteddate = validateReportedDate(formData.reporteddate);
    validationErrors.description = validateDescription(formData.description);
    validationErrors.requestedByDepartment = validateRequestedByDepartment(formData.requestedByDepartment);
    validationErrors.email = validateEmail(formData.email);
    validationErrors.contactNumber = validateContactNumber(formData.contactNumber);

    // Request type specific validations
    if (formData.requestType === "STAFF") {
      validationErrors.staffType = validateStaffType(formData.staffType);
      validationErrors.skillSet = validateSkillSet(formData.skillSet);
      validationErrors.experienceLevel = validateExperienceLevel(formData.experienceLevel);
      validationErrors.employmentType = validateEmploymentType(formData.employmentType);
    } else if (formData.requestType === "ASSET") {
      validationErrors.assetCategory = validateAssetCategory(formData.assetCategory);
      validationErrors.assetType = validateAssetType(formData.assetType);
      validationErrors.assetName = validateAssetName(formData.assetName);
      validationErrors.quantity = validateQuantity(formData.quantity);
      validationErrors.nonFunctionalUnits = validateNonFunctionalUnits(formData.nonFunctionalUnits);
    }

    setErrors(validationErrors);
    return !Object.values(validationErrors).some(error => error !== "");
  };

  // Handles form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    // Input sanitization
    if (name === "jobTitle") {
      updatedValue = value.replace(/[^A-Za-z0-9\s]/g, '');
    } else if (name === "contactNumber") {
      updatedValue = value.replace(/[^0-9]/g, '');
    } else if (name === "requestedByDepartment") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, '');
    } else if (name === "skillSet") {
      updatedValue = value.replace(/[^A-Za-z,\s]/g, '');
    } else if (name === "assetName") {
      updatedValue = value.replace(/[^A-Za-z0-9\s\-]/g, '');
    }

    setFormData(prev => ({
      ...prev,
      [name]: updatedValue
    }));

    // Mark field as touched
    setTouched(prev => ({
      ...prev,
      [name]: true
    }));

    // Validate field immediately if it's been touched before
    if (touched[name] || submitted) {
      let error = "";
      switch (name) {
        case "jobTitle": error = validateJobTitle(updatedValue); break;
        case "bankName": error = validateBankName(updatedValue); break;
        case "branchName": error = validateBranchName(updatedValue); break;
        case "assignedRole": error = validateAssignedRole(updatedValue); break;
        case "assignedUser": error = validateAssignedUser(updatedValue); break;
        case "requestType": error = validateRequestType(updatedValue); break;
        case "reporteddate": error = validateReportedDate(updatedValue); break;
        case "description": error = validateDescription(updatedValue); break;
        case "requestedByDepartment": error = validateRequestedByDepartment(updatedValue); break;
        case "email": error = validateEmail(updatedValue); break;
        case "contactNumber": error = validateContactNumber(updatedValue); break;
        case "staffType": error = validateStaffType(updatedValue); break;
        case "skillSet": error = validateSkillSet(updatedValue); break;
        case "experienceLevel": error = validateExperienceLevel(updatedValue); break;
        case "employmentType": error = validateEmploymentType(updatedValue); break;
        case "assetCategory": error = validateAssetCategory(updatedValue); break;
        case "assetType": error = validateAssetType(updatedValue); break;
        case "assetName": error = validateAssetName(updatedValue); break;
        case "quantity": error = validateQuantity(updatedValue); break;
        case "nonFunctionalUnits": error = validateNonFunctionalUnits(updatedValue); break;
        default: break;
      }

      setErrors(prev => ({
        ...prev,
        [name]: error
      }));
    }

  };

  // Handles form field blur events (for validation)
  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));

    let error = "";
    switch (name) {
      case "jobTitle": error = validateJobTitle(value); break;
      case "bankName": error = validateBankName(value); break;
      case "branchName": error = validateBranchName(value); break;
      case "assignedRole": error = validateAssignedRole(value); break;
      case "assignedUser": error = validateAssignedUser(value); break;
      case "requestType": error = validateRequestType(value); break;
      case "reporteddate": error = validateReportedDate(value); break;
      case "description": error = validateDescription(value); break;
      case "requestedByDepartment": error = validateRequestedByDepartment(value); break;
      case "email": error = validateEmail(value); break;
      case "contactNumber": error = validateContactNumber(value); break;
      case "staffType": error = validateStaffType(value); break;
      case "skillSet": error = validateSkillSet(value); break;
      case "experienceLevel": error = validateExperienceLevel(value); break;
      case "employmentType": error = validateEmploymentType(value); break;
      case "assetCategory": error = validateAssetCategory(value); break;
      case "assetType": error = validateAssetType(value); break;
      case "assetName": error = validateAssetName(value); break;
      case "quantity": error = validateQuantity(value); break;
      case "nonFunctionalUnits": error = validateNonFunctionalUnits(value); break;
      default: break;
    }

    setErrors(prev => ({
      ...prev,
      [name]: error
    }));

  };

  // Format date to required API format (DD-MM-YYYY HH:MM AM/PM)
  const formatDateForApi = (dateTimeString) => {
    const date = new Date(dateTimeString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const paddedHours = String(hours).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}-${month}-${year} ${paddedHours}:${minutes} ${ampm}`;
  };

  // Shows the cancel confirmation modal
  const handleCancel = () => {
    setShowCancelModal(true);
  };

  // Closes the cancel confirmation modal
  const closeCancelModal = () => {
    setShowCancelModal(false);
  };

  // Confirms form cancellation and resets the form
  const confirmCancel = () => {
    resetForm()
    setShowCancelModal(false);
  }

  // Prepares the request body for creating a new resource
  const prepareRequestBody = () => {
    // Common fields for both request types
    const requestBody = {
      jobTitle: formData.jobTitle,
      requestorName: username,
      bankId: parseInt(formData.bankName),
      branchId: parseInt(formData.branchName),
      requestDateAndTimeString: formatDateForApi(formData.reporteddate),
      phoneNumber: formData.contactNumber,
      email: formData.email,
      description: formData.description,
      assigned_team: formData.assignedRole,
      requestType: formData.requestType,
      reqByDepartment: formData.requestedByDepartment,
      is_deleted: false,
      createdBy: userId, // Use the fetched user ID or fallback to default
    };

    // Add request type specific data
    if (formData.requestType === "ASSET") {
      requestBody.asset_resource = [
        {
          assetCategoryId: parseInt(formData.assetCategory),
          assetTypeId: parseInt(formData.assetType),
          assetName: formData.assetName,
          quantity: parseInt(formData.quantity),
          nonFunctionalUnits: formData.nonFunctionalUnits ? parseInt(formData.nonFunctionalUnits) : 0,
          assignedTo: parseInt(formData.assignedUser),
          is_deleted: false,
          created_by: userId,
          description: "Asset Resource",
          status: 768
        }
      ];
    } else if (formData.requestType === "STAFF") {
      requestBody.staff_resource = [
        {
          staffId: parseInt(formData.staffType),
          skills: formData.skillSet || "",
          expLevel: formData.experienceLevel,
          employmentType: formData.employmentType,
          assignedTo: parseInt(formData.assignedUser),
          is_deleted: false,
          created_by: userId,
          remarks: "Staff Resource",
          status: 768
        }
      ];
    }

    return requestBody;
  };

  // Prepares the request body for updating an existing resource
  const updateBody = () => {

    const updatebody = {
      id: resourceId,
      jobTitle: formData.jobTitle,
      requestorName: username,
      bankId: parseInt(formData.bankName),
      branchId: parseInt(formData.branchName),
      requestDateAndTimeString: formatDateForApi(formData.reporteddate),
      phoneNumber: formData.contactNumber,
      email: formData.email,
      description: formData.description,
      assigned_team: formData.assignedRole,
      requestType: formData.requestType,
      reqByDepartment: formData.requestedByDepartment,
      updated_by: userId, // Use the fetched user ID or fallback to default
    };

    // Add request type specific data
    if (formData.requestType === "ASSET") {
      updatebody.asset_resource = [
        {
          id: assetResourceId,
          assetCategoryId: parseInt(formData.assetCategory),
          assetTypeId: parseInt(formData.assetType),
          assetName: formData.assetName,
          quantity: parseInt(formData.quantity),
          nonFunctionalUnits: formData.nonFunctionalUnits ? parseInt(formData.nonFunctionalUnits) : 0,
          assignedTo: parseInt(formData.assignedUser),
          updated_by: userId,
          description: ""
        }
      ];
    } else if (formData.requestType === "STAFF") {
      updatebody.staff_resource = [
        {
          id: staffResourceId,
          staffId: parseInt(formData.staffType),
          skills: formData.skillSet || "",
          expLevel: formData.experienceLevel,
          employmentType: formData.employmentType,
          assignedTo: parseInt(formData.assignedUser),
          updated_by: userId,
          remarks: ""
        }
      ];
    }

    return updatebody;

  }

  // Handles form submission
  const handleSubmit = async () => {
    setSubmitted(true);
    // Mark all fields as touched
    const touchedFields = {};
    Object.keys(formData).forEach(field => {
      touchedFields[field] = true;
    });
    setTouched(touchedFields);

    if (validateForm()) {
      try {
        if (edit) {
          const updatebody = updateBody();
          const response = await putDataWithBody(updateresource, updatebody, {})
          if (response.status === 'success') {
            toast.success(response.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });

            // Reset form after successful submission
            resetForm();
            navigate('/configurations/resource-list')
            // Call onSuccess if provided to trigger parent data refresh

          } else {
            toast.error(response.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
          }
        } else {
          const requestBody = prepareRequestBody();
          // Call the API
          const response = await postDataWithBody(saveapires, requestBody, {});
          if (response.status === 'success') {
            toast.success(response.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });

            // Reset form after successful submission
            resetForm();
            navigate('/configurations/resource-list')
            // Call onSuccess if provided to trigger parent data refresh

          } else {
            toast.error(response.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
          }
        }
      } catch (error) {
        console.error("Error submitting request:", error);
        alert("Failed to submit request. Please try again.");
      }
    } else {
      // Scroll to the first error
      const firstErrorField = document.querySelector('.error-message');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  };

  // Resets the form to its initial state
  const resetForm = () => {
    setFormData({
      jobTitle: "",
      requestorName: username,
      bankName: "",
      branchName: "",
      assignedRole: "",
      assignedUser: "",
      requestType: "",
      department: "",
      requestDate: new Date().toISOString().split('T')[0],
      reporteddate: "",
      description: "",
      requestedByDepartment: "",
      email: "",
      contactNumber: "",
      assetCategory: "",
      assetType: "",
      staffType: "",
      skillSet: "",
      experienceLevel: "",
      employmentType: "",
      assetName: "",
      quantity: "",
      nonFunctionalUnits: "",
    });
    setTouched({});
    setSubmitted(false);
    setErrors({});
    setIsEditMode(false);
    setResourceId(null);
    setAssetResourceId(null);
    setStaffResourceId(null);
  };

  // Gets the appropriate CSS class for an input field based on its state
  const getInputClass = (fieldName) => {
    const baseClass = "form-control";
    const readOnlyClass = ["requestorName", "department", "requestDate"].includes(fieldName)
      ? "form-input-readonly"
      : "";
    const errorClass = (submitted || touched[fieldName]) && errors[fieldName] ? "form-input-error" : "";
    return `${baseClass} ${readOnlyClass} ${errorClass}`.trim();
  };

  // Gets the appropriate CSS class for a select field based on its state
  const getSelectClass = (fieldName) => {
    const baseClass = "form-control";
    const errorClass = (submitted || touched[fieldName]) && errors[fieldName] ? "form-select-error" : "";
    return `${baseClass} ${errorClass}`.trim();
  };

  return (
    <div className="request-form-container">
      {isLoading ? (
        <div className="loading-container">
          <div className="loading-content">
            <div className="spinner" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="loading-text">Loading form data...</p>
          </div>
        </div>
      ) : (
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Request Type<span style={{ color: 'red' }}>*</span></label>
            <select
              name="requestType"
              className={getSelectClass("requestType")}
              value={formData.requestType}
              onChange={handleChange}
              onBlur={handleBlur}
              style={{ height: 45 }}
              disabled={isEditMode}
            >
              <option value="">Select Request Type</option>
              <option value="STAFF">STAFF</option>
              <option value="ASSET">ASSET</option>
            </select>
            {(submitted || touched.requestType) && errors.requestType &&
              <p className="error-message-resu">{errors.requestType}</p>
            }
          </div>
          <div className="form-group">
            <label className="form-label">Resource Title<span style={{ color: 'red' }}>*</span></label>
            <input
              name="jobTitle"
              className={getInputClass("jobTitle")}
              value={formData.jobTitle}
              onChange={handleChange}
              onBlur={handleBlur}

              style={{ height: 45 }}
            />
            {(submitted || touched.jobTitle) && errors.jobTitle &&
              <p className="error-message-resu">{errors.jobTitle}</p>
            }
          </div>
          <div className="form-group">
            <label className="form-label">
              Requested Date & Time<span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="datetime-local"
              name="reporteddate"
              className={getInputClass("reporteddate")}
              value={formData.reporteddate}
              onChange={handleChange}
              onBlur={handleBlur}
              max={new Date().toISOString().slice(0, 16)}
              style={{ height: 45 }}
            />
            {(submitted || touched.reporteddate) && errors.reporteddate &&
              <p className="error-message-resu">{errors.reporteddate}</p>
            }
          </div>
          <div className="form-group" style={{ width: '100%', gridColumn: 'span 2' }}>
            <label className="form-label">
              Resource Description<span style={{ color: 'red' }}>*</span>
            </label>
            <textarea
              name="description"
              className={getInputClass("description")}
              value={formData.description}
              onChange={handleChange}
              onBlur={handleBlur}

              style={{
                height: '120px',
                padding: '5px',
                lineHeight: '1.2',
                fontSize: '14px',
                resize: 'none',
                width: '100%'
              }}
            />
            {(submitted || touched.description) && errors.description &&
              <p className="error-message-resu">{errors.description}</p>
            }
          </div>

          {/* Requestor Name and Department aligned together */}
          <div style={{ display: 'flex', gap: '20px', position: 'relative' }}>
            {/* Requestor Name */}
            <div
              className="form-group"
              style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
            >
              <label className="form-label">Requestor Name</label>
              <input
                name="requestorName"
                className={getInputClass("requestorName")}
                value={username}
                readOnly
                style={{ width: '100%' }}
              />
            </div>

            {/* Requested By Department */}
            <div
              className="form-group"
              style={{
                position: 'absolute', // Allows independent placement
                top: '75px',
                left: 'calc(6% - 20px)', // Adjust this value to control horizontal alignment
                width: '100%', // Adjust as needed
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <label className="form-label">
                Requested By Department<span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                name="requestedByDepartment"
                className={getInputClass("requestedByDepartment")}
                value={formData.requestedByDepartment}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{ width: '100%' }} // Stretches to container width
              />
              {(submitted || touched.requestedByDepartment) && errors.requestedByDepartment && (
                <p className="error-message-resu">{errors.requestedByDepartment}</p>
              )}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Assigned Role<span style={{ color: 'red' }}>*</span></label>
            <select
              name="assignedRole"
              className={getSelectClass("assignedRole")}
              value={formData.assignedRole}
              onChange={handleChange}
              onBlur={handleBlur}
              style={{ height: 45 }}
            >
              <option value="">Select Role</option>
              {allrole.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
            {(submitted || touched.assignedRole) && errors.assignedRole &&
              <p className="error-message-resu">{errors.assignedRole}</p>
            }
          </div>

          <div className="form-group">
            <label className="form-label">Assigned User<span style={{ color: 'red' }}>*</span></label>
            <select
              name="assignedUser"
              className={getSelectClass("assignedUser")}
              value={formData.assignedUser}
              onChange={handleChange}
              onBlur={handleBlur}
              style={{ height: 45 }}
              disabled={!formData.assignedRole}
            >
              <option value="">Select User</option>
              {assignedUsers.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.user_name}
                </option>
              ))}
            </select>
            {(submitted || touched.assignedUser) && errors.assignedUser &&
              <p className="error-message-resu">{errors.assignedUser}</p>
            }
          </div>
          <div className="form-group">
            <label className="form-label">Email Address<span style={{ color: 'red' }}>*</span></label>
            <input
              type="email"
              name="email"
              className={getInputClass("email")}
              value={formData.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="example@company.com"
            />
            {(submitted || touched.email) && errors.email &&
              <p className="error-message-resu">{errors.email}</p>
            }
          </div>
          <div className="form-group">
            <label className="form-label">Bank Name<span style={{ color: 'red' }}>*</span></label>
            <select
              name="bankName"
              className={getSelectClass("bankName")}
              value={formData.bankName}
              onChange={handleChange}
              onBlur={handleBlur}
              style={{ height: 45 }}
            >
              <option value="">Select Bank</option>
              {bankOptions.map(bank => (
                <option key={bank.id} value={bank.id}>{bank.bankName}</option>
              ))}
            </select>
            {(submitted || touched.bankName) && errors.bankName &&
              <p className="error-message-resu">{errors.bankName}</p>
            }
          </div>

          <div className="form-group">
            <label className="form-label">Branch Name<span style={{ color: 'red' }}>*</span></label>
            <select
              name="branchName"
              className={getSelectClass("branchName")}
              value={formData.branchName}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={!formData.bankName}
              style={{ height: 45 }}
            >
              <option value="">Select Branch</option>
              {branchOptions.map(branch => (
                <option key={branch.id} value={branch.id}>{branch.branchName}</option>
              ))}
            </select>
            {(submitted || touched.branchName) && errors.branchName &&
              <p className="error-message-resu">{errors.branchName}</p>
            }
          </div>
          <div className="form-group">
            <label className="form-label">Contact Number<span style={{ color: 'red' }}>*</span></label>
            <input
              type="tel"
              name="contactNumber"
              className={getInputClass("contactNumber")}
              value={formData.contactNumber}
              onChange={handleChange}
              onBlur={handleBlur}
              maxLength={10}
              placeholder="Enter Contact Number"
            />
            {(submitted || touched.contactNumber) && errors.contactNumber &&
              <p className="error-message-resu">{errors.contactNumber}</p>
            }
          </div>

          {/* Render Staff Resource Fields */}
          {formData.requestType === "STAFF" && (
            <>
              <div className="form-group">
                <label className="form-label">Staff Type<span style={{ color: 'red' }}>*</span></label>
                <select
                  name="staffType"
                  className={getSelectClass("staffType")}
                  value={formData.staffType}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ height: 45 }}
                >
                  <option value="">Select staff</option>
                  {staffTypes.map((staff) => (
                    <option key={staff.id} value={staff.id}>
                      {staff.value}
                    </option>
                  ))}
                </select>
                {(submitted || touched.staffType) && errors.staffType &&
                  <p className="error-message-resu">{errors.staffType}</p>
                }
              </div>

              <div className="form-group">
                <label className="form-label">Required Skill Set</label>
                <input
                  type="text"
                  name="skillSet"
                  className={getInputClass("skillSet")}
                  value={formData.skillSet}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Experience Level<span style={{ color: 'red' }}>*</span></label>
                <select
                  name="experienceLevel"
                  className={getSelectClass("experienceLevel")}
                  value={formData.experienceLevel}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ height: 45 }}
                >
                  <option value="">Select Experience Level</option>
                  <option value="entry">Entry</option>
                  <option value="mid">Mid</option>
                  <option value="senior">Senior</option>
                </select>
                {(submitted || touched.experienceLevel) && errors.experienceLevel &&
                  <p className="error-message-resu">{errors.experienceLevel}</p>
                }
              </div>

              <div className="form-group">
                <label className="form-label">Employment Type<span style={{ color: 'red' }}>*</span></label>
                <select
                  name="employmentType"
                  className={getSelectClass("employmentType")}
                  value={formData.employmentType}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ height: 45 }}
                >
                  <option value="">Select Employment Type</option>
                  <option value="permanent">Permanent</option>
                  <option value="contract">Contract</option>
                  <option value="outsourced">Outsourced</option>
                </select>
                {(submitted || touched.employmentType) && errors.employmentType &&
                  <p className="error-message-resu">{errors.employmentType}</p>
                }
              </div>
            </>
          )}

          {/* Render Asset Fields */}
          {formData.requestType === "ASSET" && (
            <>
              <div className="form-group">
                <label className="form-label">Asset Category<span style={{ color: 'red' }}>*</span></label>
                <select
                  name="assetCategory"
                  className={getSelectClass("assetCategory")}
                  value={formData.assetCategory}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ height: 45 }}
                >
                  <option value="">Select Asset Category</option>
                  {assetcategory1.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.value}
                    </option>
                  ))}
                </select>
                {(submitted || touched.assetCategory) && errors.assetCategory &&
                  <p className="error-message-resu">{errors.assetCategory}</p>
                }
              </div>

              <div className="form-group">
                <label className="form-label">Asset Type<span style={{ color: 'red' }}>*</span></label>
                <select
                  name="assetType"
                  className={getSelectClass("assetType")}
                  value={formData.assetType}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  style={{ height: 45 }}
                  disabled={!formData.assetCategory}
                >
                  <option value="">Select Asset Type</option>
                  {subCategories.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.value}
                    </option>
                  ))}
                </select>
                {(submitted || touched.assetType) && errors.assetType &&
                  <p className="error-message-resu">{errors.assetType}</p>
                }
              </div>

              <div className="form-group">
                <label className="form-label">Asset Name<span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="assetName"
                  className={getInputClass("assetName")}
                  value={formData.assetName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="e.g., Laptop – Dell Latitude 7420"
                />
                {(submitted || touched.assetName) && errors.assetName &&
                  <p className="error-message-resu">{errors.assetName}</p>
                }
              </div>

              <div className="form-group">
                <label className="form-label">Quantity Required<span style={{ color: 'red' }}>*</span></label>
                <input
                  type="number"
                  name="quantity"
                  className={getInputClass("quantity")}
                  value={formData.quantity}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  min="1"
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === 'e' || e.key === '+') {
                      e.preventDefault();
                    }
                  }}
                />
                {(submitted || touched.quantity) && errors.quantity &&
                  <p className="error-message-resu">{errors.quantity}</p>
                }
              </div>

              <div className="form-group">
                <label className="form-label">Non-functional Units</label>
                <input
                  type="number"
                  name="nonFunctionalUnits"
                  className={getInputClass("nonFunctionalUnits")}
                  value={formData.nonFunctionalUnits}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  min="0" d
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === 'e' || e.key === '+') {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
            </>
          )}
          {!edit ?
            <div className="form-submit-container full-width-field">
              <button
                type="button"
                className="branch-save-submit-btn btn btn-success" onClick={handleSubmit} style={{ backgroundColor: '#1a7a73', fontFamily: 'Poppins', fontSize: '14px' }}>
                Save & Submit
              </button>
              <button
                type="button"
                className="branch-save-submit-btn btn btn-success" onClick={handleCancel} style={{ backgroundColor: '#1a7a73', fontFamily: 'Poppins', fontSize: '14px', marginLeft: '10px' }}>
                Cancel
              </button>
            </div>
            :
            <div className="form-submit-container full-width-field">
              <button
                type="button"
                className="branch-save-submit-btn btn btn-success" onClick={handleSubmit} style={{ backgroundColor: '#1a7a73', fontFamily: 'Poppins', fontSize: '14px' }}>
                Update
              </button>
            </div>}
        </div>

      )}
      <Modal
        show={showCancelModal}
        onHide={closeCancelModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Would you like to clear the input values?</p>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: 'right' }}>
          <button
            className="btn"
            style={{
              backgroundColor: 'lightgray',
              color: '#000',
              marginRight: '10px'
            }}
            onClick={closeCancelModal}
          >
            No
          </button>
          <button
            className="btn"
            style={{
              backgroundColor: 'green',
              color: '#fff'
            }}
            onClick={confirmCancel}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateResourceRegForm;